import "react-app-polyfill/ie11"
import "react-app-polyfill/stable";
import React from 'react'
import './index.scss'
import App from './components/App'
import * as serviceWorker from './serviceWorker'
import config from './config'
import {
  BrowserRouter as Router
} from "react-router-dom"
import Modal from 'react-modal'
import { Buffer } from 'buffer'
import { createRoot } from 'react-dom/client'

// TODO: CRA 5 removed polyfills. Remove this when we have a better solution
// If we don't have a value for Buffer (node core module) create it/polyfill it
if (window.Buffer === undefined) window.Buffer = Buffer;


Modal.setAppElement('#root');

// Fix for Google Translate
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error('Cannot remove a child from a different parent', child, this)
      }
      return child
    }
    return originalRemoveChild.apply(this, arguments)
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error('Cannot insert before a reference node from a different parent', referenceNode, this)
      }
      return newNode
    }
    return originalInsertBefore.apply(this, arguments)
  }
}

createRoot(document.getElementById('root'))
  .render(<Router basename={config.basename}><App /></Router>)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
